var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from '../../../pages/modules/base-entity';
import { autoinject, BindingEngine, transient } from 'aurelia-framework';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { Router } from 'aurelia-router';
import { NotificationClientService, NotificationType } from '../../../../services/basics/notification-client.service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { EntityTypes } from '../../../../models/basics/basics.models';
import { RouterConstants } from '../../../../configuration/router.constants';
import { StepEnum, LotteryFeedEnum, LotteryJackpotDrawStatusEnum } from '../../../../models/modules/lotteryplatofrm.models';
import { LotteryClientService } from '../../../../services/modules/lottery-client.service';
import { I18N } from 'aurelia-i18n';
import { TokenClient } from '../../../../services/authentication/token-client.service';
import { ValidationRules, ValidationControllerFactory, validateTrigger } from "aurelia-validation";
import * as Enumerable from 'linq';
import { AttachmentClientService } from '../../../../services/modules/attachements-client.service';
import { Guid } from '../../../../utilities/guid';
import { LotteryBasicMeta } from './steps/lottery-basic-meta';
import { LotteryAnalytics } from './steps/lottery-analytics';
import { LotteryTickets } from './steps/lottery-tickets';
import { LotterySettings } from './steps/lottery-settings';
import { LotteryPriceTiers } from './steps/lottery-price-tiers';
import { LotteryTicketDiscounts } from './steps/lottery-ticket-discounts';
import { LotteryMarginCosts } from './steps/lottery-platform-margins';
import { LotteryChangeLog } from './steps/lottery-changelog';
import { BrandClientService } from '../../../../services/modules/brand-client.service';
import { LotteryTicketLines } from './steps/lottery-ticket-lines';
import { UserClaimsService } from '../../../../services/authentication/user-claims.service';
import { BaseClaims } from '../../../../constants/authentication/base-claims';
import { LotteryPlatformClaims } from '../../../../constants/modules/lotteryplatform.claims';
import { LotteryFaq } from "./steps/lottery-faq";
import { LotterySyndicates } from "./steps/lottery-syndicates";
import { LotteryBrandSettings } from './steps/lottery-brand-settings';
import { DialogServiceConstants } from '../../../../constants/basics/dialog.constants';
var Lottery = /** @class */ (function (_super) {
    __extends(Lottery, _super);
    function Lottery(attachmentClientService, validationControllerFactory, dialogClientService, tokenClient, router, bindingEngine, notificationService, eventAggregator, lotteryClientService, i18N, lotteryBasicMeta, lotteryAnalytics, lotteryPriceTiers, userClaimsService, lotteryTickets, lotterySettings, lotteryBrandSettings, lotteryTicketDicounts, lotteryMarginCosts, lotteryChangeLog, brandClientService, lotteryTicketLines, lotteryFaq, lotterySyndicates) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.attachmentClientService = attachmentClientService;
        _this.validationControllerFactory = validationControllerFactory;
        _this.dialogClientService = dialogClientService;
        _this.tokenClient = tokenClient;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.lotteryClientService = lotteryClientService;
        _this.lotteryBasicMeta = lotteryBasicMeta;
        _this.lotteryAnalytics = lotteryAnalytics;
        _this.lotteryPriceTiers = lotteryPriceTiers;
        _this.userClaimsService = userClaimsService;
        _this.lotteryTickets = lotteryTickets;
        _this.lotterySettings = lotterySettings;
        _this.lotteryBrandSettings = lotteryBrandSettings;
        _this.lotteryTicketDicounts = lotteryTicketDicounts;
        _this.lotteryMarginCosts = lotteryMarginCosts;
        _this.lotteryChangeLog = lotteryChangeLog;
        _this.brandClientService = brandClientService;
        _this.lotteryTicketLines = lotteryTicketLines;
        _this.lotteryFaq = lotteryFaq;
        _this.lotterySyndicates = lotterySyndicates;
        _this._isOpenedFromLotteryAdmin = 'true';
        _this._isOpenedFromBrandAdmin = 'false';
        _this.activityLogEntitiesSave = [EntityTypes.Lottery];
        _this.controller = null;
        _this.controller = validationControllerFactory.createForCurrentScope();
        _this.controller.validateTrigger = validateTrigger.changeOrBlur;
        return _this;
    }
    Object.defineProperty(Lottery.prototype, "defaultLottery", {
        get: function () {
            return {
                name: null,
                createdDate: new Date(),
                lotteryApiCode: null,
                insurerApiCode: null,
                fetchResultsDate: null,
                drawTimeHours: null,
                drawTimeMinutes: null,
                ticketSalesClosingTimeOffsetInMinutes: null,
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                isCustom: false,
                minimumJackpot: 0,
                incrementJackpot: 0,
                maximumJackpot: 0,
                maximumJackpotDuration: 0,
                countryId: null,
                timezone: null,
                drawMinimumNumber: null,
                drawMaximumNumber: null,
                drawnNumbers: null,
                feedDrawnNumbers: null,
                drawnBonusMinimumNumber: null,
                drawnBonusMaximumNumber: null,
                drawnBonusNumbers: null,
                feedDrawnBonusNumbers: null,
                minimumTicketPrice: null,
                useLotteryComAPI: false,
                currencyId: null,
                ticketPrice: 0,
                isActive: true,
                notes: null,
                currentJackpotDraw: {
                    drawDate: null,
                    lotteryLocalDrawDate: null,
                    totalJackpot: 0,
                    dateResultAdded: null,
                    results: null,
                    lotteryJackpotDrawStatusId: LotteryJackpotDrawStatusEnum.NA,
                },
                lotteryJackpotDraws: [],
                lotteryPricingModels: [],
                brandLotteries: [],
                lotteryPriceTiers: [],
                insurancePayoutPolicyDeduction: 23,
                underlyingLotteryName: null,
                insurerLotteryName: null,
                lotteryAdditionalInfo: {
                    faq: null
                },
                lotteryAdditionalInfoId: null,
                entityType: EntityTypes.Lottery,
                identifier: Guid.generateGuid(),
                gameIdentifier: null,
                lotteryFeedId: null,
                drawTimeTo: null,
                drawTimeFrom: null,
                hourlyInterval: null,
                enableHourlyInterval: null,
                isFeed: false,
                rngDrawUrl: null,
                rngResultUrl: null,
                isRngNotAvailable: false,
                allowCalculateNextDrawDateManually: true,
                insurancePercentage: 100,
                // Must be initialized so the UnitOfWork observer tracks "Is FONB" changes on new lotteries.
                isFonb: false
            };
        },
        enumerable: false,
        configurable: true
    });
    Lottery.prototype.activate = function (params, navigationInstruction) {
        var _this = this;
        if (params.isOpenedFromLotteryAdmin)
            this._isOpenedFromLotteryAdmin = params.isOpenedFromLotteryAdmin;
        if (params.isOpenedFromBrandAdmin)
            this._isOpenedFromBrandAdmin = params.isOpenedFromBrandAdmin;
        var brandId = params.brandId;
        if (brandId)
            this.brandClientService.getBrandCurrencies({ brandId: brandId }).then(function (response) {
                _this._brandCurrencies = response.brandCurrencies;
            }).catch(function () {
            });
        return _super.prototype.activate.call(this, params, navigationInstruction);
    };
    Lottery.prototype.attached = function () {
        if (!this.item.lotteryId) {
            this.item.gameIdentifier = Guid.generateGuid();
        }
        $(".oa-drag").remove();
        return _super.prototype.attached.call(this);
    };
    Lottery.prototype.initializeItemOverride = function (newItem) {
        if (newItem) {
            newItem.createdDate = new Date();
            this.initValidations(newItem);
        }
    };
    Lottery.prototype.initializeItemOverrideForUpdate = function (newItem) {
        newItem.navigationInfo = {
            brandId: this._params.brandId,
            brandName: this._params.brandName,
            brandLanguages: this._params.brandLanguages,
            brandDefaultCurrencyId: this._params.brandDefaultCurrencyId,
            operatorId: this._params.operatorId,
            operatorName: this._params.operatorName,
            operatorDefaultCurrencyId: this._params.operatorDefaultCurrencyId,
            canCreateSyndicates: this._params.canCreateSyndicates
        };
        newItem.brandTemplateInternalName = this._params.brandTemplateInternalName ? this._params.brandTemplateInternalName : "";
        newItem.brandThemeInternalName = this._params.brandThemeInternalName ? this._params.brandThemeInternalName : "";
        this.initValidations(newItem);
    };
    Lottery.prototype.initValidations = function (newItem) {
        var _this = this;
        ValidationRules.customRule('rngResultParametersRequired', function (value, obj) {
            var rngResultParameters = ["{ApiDrawID}", "{LotteryApiCode}"];
            var isValid = true;
            if (value != null || value != undefined) {
                for (var i = 0; i < rngResultParameters.length; i++) {
                    if (!value.toLowerCase().includes(rngResultParameters[i].toLowerCase())) {
                        isValid = false;
                    }
                }
            }
            return isValid;
        }, "${$displayName} must have the following parameters: {ApiDrawID}, {LotteryApiCode}.");
        ValidationRules.customRule('rngDrawPrametersValidation', function (value, obj) {
            var requiredParameters = ["{LotteryApiCode}".toLowerCase()];
            var optionalParameter = ["{DrawDateTime-DDMMYYYY}".toLowerCase(), "{DrawDateTime-YYYYMMDD}".toLowerCase(), "{DrawDateTime-MMDDYYYY}".toLowerCase()];
            var isValid = true;
            if (value != null || value != undefined) {
                for (var i = 0; i < requiredParameters.length; i++) {
                    if (!value.toLowerCase().includes(requiredParameters[i].toLowerCase())) {
                        isValid = false;
                    }
                }
                //loop to confirm that the special parameters actually match for what should be accepted
                var splitValue = value.split("/");
                for (var i = 0; i < splitValue.length; i++) {
                    if (splitValue[i].includes("{") && !requiredParameters.includes(splitValue[i].toLowerCase())) {
                        if (!optionalParameter.includes(splitValue[i].toLowerCase())) {
                            isValid = false;
                        }
                    }
                }
            }
            return isValid;
        }, "${$displayName} must have at least the following parameter: {LotteryApiCode}.");
        this.rules = ValidationRules
            .ensure(function (x) { return x.lotteryApiCode; }).required().when(function (x) { return !x.isFeed && !x.isRngNotAvailable; }).withMessage("Lottery API code is required.")
            .ensure(function (x) { return x.lotteryFeedId; }).required().withMessage("Please select a Lottery Feed option.")
            .ensure(function (x) { return x.insurerApiCode; }).required().withMessage("Insurer API code is required.")
            .ensure(function (x) { return x.underlyingLotteryName; }).required().withMessage("Underlying lottery name is required.")
            .ensure(function (x) { return x.insurerLotteryName; }).required().withMessage("Insurer lottery name is required.")
            .ensure(function (x) { return x.drawTimeHours; }).satisfies(function (x) {
            return x !== 0;
        }).required().withMessage("Draw time hours are required.")
            .ensure(function (x) { return x.drawTimeMinutes; }).required().withMessage("Draw time minutes are required.")
            .ensure(function (x) { return x.ticketSalesClosingTimeOffsetInMinutes; }).required().withMessage("Sales Closing Time Offset is required.")
            .ensure(function (x) { return x.name; }).required().withMessage("Name is required.")
            .ensure(function (x) { return x.timezone; }).required().withMessage("Timezone is required.")
            .ensure(function (x) { return x.countryId; }).required().withMessage("Country is required.")
            .ensure(function (x) { return x.drawMinimumNumber; }).required().withMessage("Main Number Minimum required.")
            .ensure(function (x) { return x.drawMaximumNumber; }).required().withMessage("Main Number Maximum is required.")
            .ensure(function (x) { return x.drawnNumbers; }).required().withMessage("Main Numbers Drawn is required.")
            .ensure(function (x) { return x.feedDrawnNumbers; }).required().withMessage("Feed Main Numbers Drawn is required.")
            .ensure(function (x) { return x.currencyId; }).required().withMessage("Currency is required.")
            .ensure(function (x) { return x.rngDrawUrl; }).required().when(function (x) { return x.lotteryFeedId == LotteryFeedEnum.RNG && !x.isRngNotAvailable; })
            .satisfiesRule('rngDrawPrametersValidation')
            .withMessage("RNG Draw url parameter is invalid. Please make sure to include the required special parameters")
            .ensure(function (x) { return x.rngResultUrl; }).required().when(function (x) { return x.lotteryFeedId == LotteryFeedEnum.RNG && !x.isRngNotAvailable; }).satisfiesRule('rngResultParametersRequired')
            .withMessage("RNG Result Url is not valid. Please make sure to include the required special parameters")
            .ensure(function (x) { return x.brandLotteries; }).satisfies(function (x) {
            if (!x || !x[0] || !x[0].brandLotteryRestrictedCountries || x[0].brandLotteryRestrictedCountries.length <= 0)
                return true;
            return Enumerable.from(x[0].brandLotteryRestrictedCountries).all(function (a) { return a.countryId > 0; });
        })
            .withMessage("Restricted countries must have a value")
            .ensure(function (x) { return x.lotteryPricingModels; })
            .satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).where(function (x) { return x.brandId > 0 || x.operatorId > 0; });
            var isValid = true;
            if (lotteryBrandPrices.toArray().length == 1) {
                lotteryBrandPrices.selectMany(function (y) { return y.lotteryBrandPrices; }).forEach(function (v) { if (v.price == null || v.price == 0)
                    isValid = false; });
            }
            return isValid;
        }).withMessage("Enter a valid ticket price for every range. Prices cannot be left empty or zero.")
            .ensure(function (x) { return x.lotteryPricingModels; })
            .satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).where(function (x) { return x.brandId > 0 || x.operatorId > 0; });
            var isValid = true;
            if (lotteryBrandPrices.toArray().length == 1) {
                lotteryBrandPrices.selectMany(function (y) { return y.lotteryBrandPrices; }).forEach(function (v) { if (v.currencyId == null || v.currencyId == 0)
                    isValid = false; });
            }
            return isValid;
        }).withMessage("Currency field cannot be empty.")
            .ensure(function (x) { return x.lotteryPricingModels; })
            .satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).where(function (x) { return x.brandId > 0 || x.operatorId > 0; });
            var isValid = true;
            if (lotteryBrandPrices.toArray().length == 1) {
                var brandPriceArray = lotteryBrandPrices.selectMany(function (y) { return y.lotteryBrandPrices; }).where(function (x) { return x.lotteryJackpotRangeId == null
                    && x.currencyId != 0; }).select(function (x) { return x.currencyId; }).toArray();
                if ((new Set(brandPriceArray)).size !== brandPriceArray.length) {
                    isValid = false;
                }
            }
            return isValid;
        }).withMessage("You cannot select same currency.Please check it.")
            .ensure(function (x) { return x.lotteryPricingModels; }).satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).selectMany(function (x) { return x.lotteryBrandDiscounts; });
            var allNumberOfDrawsNotEqualToZero = lotteryBrandPrices.all(function (x) { return x.numberOfDraws != 0; });
            return allNumberOfDrawsNotEqualToZero;
        }).withMessage("Cannot have number of draws with the value 0 in ticket discounts.")
            .ensure(function (x) { return x.lotteryPricingModels; }).satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).selectMany(function (x) { return x.lotteryBrandDiscounts; });
            var checkAnyDuplicate = lotteryBrandPrices.groupBy(function (x) { return x.numberOfDraws; }).any(function (x) { return x.count() > 1; });
            return !checkAnyDuplicate; //checkAnyDuplicate ? false : true;
        }).withMessage("Cannot have duplicate number of draws in ticket discounts.")
            .ensure(function (x) { return x.lotteryPricingModels; })
            .displayName("Lottery Platform Margin Cost")
            .satisfies(function (x) {
            var lotteryMarginCosts = Enumerable.from(x)
                .selectMany(function (x) { return x.lotteryMarginCosts; })
                .orderBy(function (x) { return x.lotteryJackpotRange.rangeFrom; });
            if (lotteryMarginCosts.all(function (x) { return x.lotteryPlatformMarginCost == null || x.lotteryPlatformMarginCost.toString() == ''; })) {
                return true;
            }
            return lotteryMarginCosts.all(function (x) { return x.lotteryPlatformMarginCost > 0; });
        }).withMessage("Lottery platform margin cost should be greater than 0. Leave the textbox empty if the Lottery Platform Margin cost doesn't apply for this lottery")
            .ensure(function (x) { return x.lotteryPricingModels; })
            .displayName("Lottery Platform Margin Cost")
            .satisfies(function (x) {
            var lotteryMarginCosts = Enumerable.from(x)
                .selectMany(function (x) { return x.lotteryMarginCosts; })
                .where(function (x) { return x.lotteryPlatformMarginCost != null; })
                .orderBy(function (x) { return x.lotteryJackpotRange.rangeFrom; });
            var previousMarginValue = 0;
            var previousMarginValidationStatus = true;
            lotteryMarginCosts.forEach(function (x) {
                if (x.lotteryPlatformMarginCost < previousMarginValue) {
                    previousMarginValidationStatus = false;
                    return false;
                }
                previousMarginValue = x.lotteryPlatformMarginCost;
            });
            return previousMarginValidationStatus;
        }).withMessage("Lottery platform margin cost should always be greater than previous range. ${lotteryPlatformMarginCost}")
            .ensure(function (x) { return x.lotteryPricingModels; })
            .satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).selectMany(function (y) { return y.lotteryBrandDiscounts; });
            var oneDraw = lotteryBrandPrices.all(function (y) { return y.numberOfDraws == 1; });
            return _this.item.useLotteryComAPI ? oneDraw : true;
        }).withMessage("Cannot set more than 1 draw for Lottery.com lotteries.")
            .ensure(function (x) { return x.insurancePercentage; }).required().withMessage("Insurance Percentage is required.")
            .ensure(function (x) { return x.insurancePercentage; }).satisfies(function (x) { return x > 0; }).withMessage("Insurance Percentage must be greater than 0")
            // All FONB tier rules are now owned by the backend (LotteryDataAccess.ValidateFonbConfiguration):
            //  - Fixed Amount + Per Player are FORCED on save (EnsureFonbJackpotRanges), so they can never be wrong.
            //  - Payout multiple > 0, exactly one jackpot range, and the compliance cap (price x multiple <= Max
            //    Payout) are validated server-side with clear per-tier messages.
            // They are intentionally NOT duplicated as global front-end rules here: these rules fire on every
            // wizard tab (incl. the brand-level Ticket Prices / Discounts tabs where tiers aren't editable), so a
            // half-configured tier would otherwise block unrelated brand-pricing saves with no way to fix it.
            .on(newItem)
            .rules;
        this.tierRules = ValidationRules
            .ensure(function (x) { return x.name; }).required().withMessage("Prize Tier Name is required.")
            .ensure(function (x) { return x.insuranceTierName; }).required().withMessage("Insurance Name is required.")
            .ensure(function (x) { return x.internalName; }).required().withMessage("Internal Name is required.")
            .ensure(function (x) { return x.lotteryTierClassId; }).satisfies(function (x) { return x > 0; }).withMessage("Prize Tier Class is required")
            .ensure(function (x) { return x.odds; }).satisfies(function (x) { return x > 0; }).withMessage("Odds must be greater than 0.")
            .ensure(function (x) { return x.lotteryJackpotRanges; })
            .satisfies(function (val) {
            // FONB ranges are generated server-side (0 -> price x multiple); skip the manual-entry rule.
            if (_this.item.isFonb)
                return true;
            var isValid = true;
            val.forEach(function (v) { if (v.rangeFrom > v.rangeTo || v.rangeFrom == null || v.rangeTo == 0)
                isValid = false; });
            return isValid;
        }).withMessage("Ranges is incorrect. Both ranges are required and range from cannot be smaller than range to.")
            .rules;
    };
    Lottery.prototype.getPropertiesToSkip = function () {
        return ["navigationInfo"];
    };
    Lottery.prototype.getSteps = function () {
        var showBrandTabs = this.tokenClient.isBrandAdmin();
        var isBrandContext = this._isOpenedFromBrandAdmin == 'true';
        // Grant-to-reveal: without ManageBrandLottery the brand lottery page is read-only (advanced tabs hidden).
        var canManageBrandLottery = !isBrandContext
            || this.userClaimsService.hasPermission(LotteryPlatformClaims.ManageBrandLottery);
        var stepList = [];
        stepList.push({
            title: this.i18N.tr('lottery-basic-meta'),
            step: StepEnum.LotteryBasicMeta,
            show: true,
            vm: this.lotteryBasicMeta,
            view: '../../app/admin/lottery/steps/lottery-basic-meta.html'
        });
        if (this._isOpenedFromLotteryAdmin == 'true' || this._isOpenedFromBrandAdmin == "true") {
            stepList.push({
                title: this.i18N.tr('lottery-analytics'),
                step: StepEnum.LotteryAnalytics,
                vm: this.lotteryAnalytics,
                show: canManageBrandLottery,
                view: '../../app/admin/lottery/steps/lottery-analytics.html'
            });
            stepList.push({
                title: this.i18N.tr('ticket-lines'),
                step: StepEnum.LotteryTicketLines,
                show: true,
                vm: this.lotteryTicketLines,
                view: '../../app/admin/lottery/steps/lottery-ticket-lines.html'
            });
            stepList.push({
                title: this.i18N.tr('change-log'),
                step: StepEnum.LotteryChangeLog,
                vm: this.lotteryChangeLog,
                show: canManageBrandLottery && this.userClaimsService.hasPermission(BaseClaims.ViewAuditHistory),
                view: '../../app/admin/lottery/steps/lottery-changelog.html'
            });
            stepList.push({
                title: this.i18N.tr('lottery-faq'),
                step: StepEnum.LotteryFaq,
                vm: this.lotteryFaq,
                show: canManageBrandLottery,
                view: '../../app/admin/lottery/steps/lottery-faq.html'
            });
        }
        if (this._isOpenedFromLotteryAdmin == 'true') {
            stepList.push({
                title: this.i18N.tr('lottery-price-tiers'),
                step: StepEnum.LotteryPriceTiers,
                vm: this.lotteryPriceTiers,
                show: !showBrandTabs,
                view: '../../app/admin/lottery/steps/lottery-price-tiers.html'
            });
            stepList.push({
                title: this.i18N.tr('lottery-settings'),
                step: StepEnum.LotterySettings,
                vm: this.lotterySettings,
                show: !showBrandTabs,
                view: '../../app/admin/lottery/steps/lottery-settings.html'
            });
        }
        else {
            stepList.push({
                title: this.i18N.tr('lottery-tickets-prices'),
                step: StepEnum.LotteryTickets,
                vm: this.lotteryTickets,
                show: canManageBrandLottery,
                view: '../../app/admin/lottery/steps/lottery-tickets.html'
            });
            stepList.push({
                title: this.i18N.tr('lottery-tickets-discounts'),
                step: StepEnum.LotteryTicketDiscounts,
                vm: this.lotteryTicketDicounts,
                show: canManageBrandLottery,
                view: '../../app/admin/lottery/steps/lottery-ticket-discounts.html'
            });
            stepList.push({
                title: this.i18N.tr('lottery-platform-margins'),
                step: StepEnum.LotteryPlatformMargins,
                vm: this.lotteryMarginCosts,
                show: canManageBrandLottery,
                view: '../../app/admin/lottery/steps/lottery-platform-margins.html'
            });
        }
        if (this._isOpenedFromBrandAdmin == "true") {
            stepList.push({
                title: this.i18N.tr('lottery-settings'),
                step: StepEnum.LotterySettings,
                vm: this.lotteryBrandSettings,
                show: canManageBrandLottery,
                view: '../../app/admin/lottery/steps/lottery-brand-settings.html'
            });
            stepList.push({
                loadOnceClicked: true,
                title: this.i18N.tr("brand-lottery-syndicates"),
                step: StepEnum.BrandLotterySyndicates,
                vm: this.lotterySyndicates,
                show: canManageBrandLottery,
                view: '../../app/admin/lottery/steps/lottery-syndicates.html'
            });
        }
        return stepList;
    };
    // Inherited
    Lottery.prototype.getItem = function (id) {
        var _this = this;
        var request = {
            id: id,
            brandId: this._params.brandId,
            operatorId: this._params.operatorId,
        };
        return this.lotteryClientService.getLotteryForAdmin(request)
            .then(function (lottery) {
            _this.normalizeFonbTierFields(lottery);
            return lottery;
        });
    };
    Lottery.prototype.normalizeFonbTierFields = function (lottery) {
        if (!lottery || !lottery.lotteryPriceTiers) {
            return;
        }
        lottery.lotteryPriceTiers.forEach(function (tier) {
            if (tier.payoutMultiple === undefined) {
                tier.payoutMultiple = lottery.isFonb ? 0 : null;
            }
        });
    };
    Lottery.prototype.getItemId = function () {
        return this.item.lotteryId;
    };
    Lottery.prototype.getEntityType = function () {
        return EntityTypes.Lottery;
    };
    Lottery.prototype.saveItem = function (id, changes) {
        var request = {
            id: id,
            changes: changes,
            // only pass the brandId | operatorId if the navigation info is not null i.e. if we ar ein a Manage Brand  | Manage Operator
            brandId: this._params.brandId ? this._params.brandId : this.item.navigationInfo ? this.item.navigationInfo.brandId : null,
            operatorId: this._params.operatorId ? this._params.operatorId : this.item.navigationInfo ? this.item.navigationInfo.operatorId : null
        };
        return this.lotteryClientService.save(request);
    };
    Lottery.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageLottery;
    };
    Lottery.prototype.initializeItemForCreate = function () {
        return this.defaultLottery;
    };
    Lottery.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListLotteries;
    };
    Lottery.prototype.deleteLottery = function () {
        var _this = this;
        require("../dialogs/delete-modal"); // this is to show delete modal dialog
        if (this.item.lotteryId) {
            this.dialogClientService.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
                delete: function () { return new Promise(function (resolve, reject) {
                    _this.lotteryClientService.delete({ lotteryId: _this.item.lotteryId }).then(function (response) {
                        if (response.deleteSuccessfully) {
                            _this.notificationService.show(_this.i18N.tr("lottery-delete-notification-title"), _this.i18N.tr("lottery-delete-notification-message-success"), NotificationType.Success);
                            _this.router.navigateToRoute(_this.getListRoute());
                            resolve();
                        }
                        else {
                            _this.notificationService.show(_this.i18N.tr("lottery-delete-notification-title"), _this.i18N.tr("lottery-delete-notification-message-error"), NotificationType.Error);
                            reject();
                        }
                    }).catch(function () {
                        _this.notificationService.show(_this.i18N.tr("lottery-delete-notification-title"), _this.i18N.tr("lottery-delete-notification-message-error"), NotificationType.Error);
                        reject();
                    });
                }); }
            });
        }
    };
    Lottery.prototype.beforeSave = function (skipValidation, resolve) {
        var _this = this;
        if (this.lotteryTickets.arePricesBeingCalculated) {
            alert("You have to wait until all prices are being updated");
            return;
        }
        // FONB jackpot ranges (0 -> price x multiple) are generated server-side on save; nothing to do here.
        Promise.all([
            this.controller.validate({ object: this.item, rules: this.rules }),
        ].concat(Enumerable.from(this.item.lotteryPriceTiers).select(function (a) { return _this.controller.validate({ object: a, rules: _this.tierRules }); }).toArray())).then(function (result) {
            resolve(Enumerable.from(result).all(function (x) { return x.valid; }), _this.controller.errors.map(function (x) { return x.message; }).join("\n"));
        });
    };
    Lottery.prototype.getSaveConfirmation = function () {
        return this.getRenameAwareSaveConfirmation();
    };
    Lottery = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [AttachmentClientService, ValidationControllerFactory,
            DialogClientService, TokenClient,
            Router, BindingEngine, NotificationClientService,
            EventAggregator, LotteryClientService, I18N,
            LotteryBasicMeta, LotteryAnalytics,
            LotteryPriceTiers, UserClaimsService,
            LotteryTickets, LotterySettings,
            LotteryBrandSettings,
            LotteryTicketDiscounts, LotteryMarginCosts,
            LotteryChangeLog,
            BrandClientService, LotteryTicketLines,
            LotteryFaq, LotterySyndicates])
    ], Lottery);
    return Lottery;
}(BaseEntity));
export { Lottery };
